module.exports = __webpack_public_path__ + "static/media/feedbackd.24e350f2.svg";